import { ThemeProps } from '@hhgtech/hhg-components'
import { sanitizer } from 'components/atoms/FormatInnterHTML'
import { Heading } from 'components/atoms/text'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const WrapperKeyTakeAways = styled.article`
  padding: 16px;
  margin: 16px auto;
  background-color: ${(props: ThemeProps) => props.theme.mbColors.toneYellow};
  border-radius: 8px;
  .header-key-takeaways {
    padding: 8px 0px;
    border-bottom: 2px solid ${(props) => props.theme.mbColors.orange};
    color: ${(props) => props.theme.mbColors.orange};
  }
  .content-key-takeaways {
    padding: 8px 0px;
    color: ${(props) => props.theme.mbColors.gray};
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.2px;
    line-height: 24px;
  }
`

interface IKeyTakeAways {
  keyTakeaways: string
}

const KeyTakeAways = ({ keyTakeaways }: IKeyTakeAways) => {
  const { formatMessage: f } = useIntl()
  return (
    <WrapperKeyTakeAways className="wrapper-key-takeaways">
      <Heading type="h4" className="header-key-takeaways">
        {f({ id: 'articlePage.keyTakeAways' })}
      </Heading>
      <div
        className="content-key-takeaways"
        dangerouslySetInnerHTML={{ __html: sanitizer(keyTakeaways) }}
      />
    </WrapperKeyTakeAways>
  )
}

export default KeyTakeAways
